






$.fn.formatDouble = function (decimals) {
    this.formatCurrency({ region: 'de-DE', symbol: '', decimalSymbol: ',', digitGroupSymbol: '.', roundToDecimalPlace: decimals, negativeFormat: '-%n' });
    return this;
};


$.fn.destroyObjects = function () {
	
	return this.each(function (i, element) {
		$.each($(element).data(), function (i, data) {
			if ($.isFunction(data.destroy)) {
				
				data.destroy();
			}
		});
	});
};


jQuery.expr[':'].contains = function (a, i, m) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};


function vcCommon() {
	this.getSumTypeFromBsagid = function (bsagid) {
		switch (bsagid) {
			case "18": return 7; //power
			case "19": return 8; //heat
			case "20": return 9; //water
			case "21": return 3; //temperature
			case "91": return 15; //cold
		    case "95": return 56; //ventilation
		    case "115": return -1; //pollution
		}
		return -1;
    }

	this.getVisualSufixFromBsagid = function (bsagid) {
		switch (bsagid) {
			case "18": return "POWER"; //power
			case "19": return "HEAT"; //heat
			case "20": return "WATER"; //water
			case "21": return "TEMP"; //temperature
			case "22": return "METEOROLOGY"; //temperature
			case "91": return "COLD"; //cold
		    case "95": return "VENTILATION"; //ventilation
		    case "115": return "POLLUTION"; //polution
		}
		return -1;
    }

	this.getLoadingIcon = function () {
		return "<img src='../../images/visualcore/loading.gif' style='height:15px' alt='" + window._RESOURCES.JS_Com.loading_lbl + "'  /> " + window._RESOURCES.JS_Com.loading_lbl;
    }

	this.expandTags = function (tags) {
	    /// <summary>
	    /// This function iterates all raw tag items and adds a proper design for each of them.
	    /// </summary>
	    var tagList;
	    var sTmp = "";
	    var tag;
		try {

		
	        if (tags === null) { return "" }
	        if (tags.length === 0) { return "" }
	    
	            tagList = tags.split(";;;");
		

			for (var j = 0; j <= tagList.length - 1; j++) {




	                sTmp += "<div class='vc-tags-item";
	                tag = JSON.parse(tagList[j]);
	                if (tag.length > 2) {
	                    if (tag[2] === '1') {
	                        sTmp += " vc-tags-item-system";
	                    }
	                    if (tag[2] === '2') {
	                        sTmp += " vc-tags-item-equip";
	                    }
	                }


	                sTmp += "'";
	                if (tag[1].length > 0) {
	                    if (tag[2] === '2') {
	                        if (tag[0] !== tag[1]) {
	                            sTmp += " title='" + tag[0] + " / " + tag[1] + "'";
	                        } else {
	                            sTmp += " title='" + tag[0] + "'";
	                        }
	                    } else {
	                        sTmp += " title='" + tag[1] + "'";
	                    }
	                } else {

	                    sTmp += " title='" + tag[0] + "'";
	       

				    }

	                sTmp += ">";

	                switch (tag[3]) {
	                    case "2":
	                        sTmp += "<i class='fa fa-building' ></i> ";
	                        break;
	                    case "999":
	                        sTmp += "<i class='fa fa-tachometer-alt' ></i> ";
	                        break;
						default:
					}




                    sTmp += "<div class='c'>" + tag[0] + "</div>";
	                if (tag[1].length > 0) {
	                    sTmp += "<span>" +  tag[1] + "</span>";
	                }
					sTmp += "</div>";


					//console.info(tag);
					////console.info(tagList[j]);
					//console.info(sTmp);
	            }

			//console.info(sTmp);

	        return sTmp;
	       
	    } catch (ex) {
			console.info(ex);
            writeError('js.expandTags', ex); return ""
        }
    };

	this.navigateCalendar = function (id, txtDateInterval, txtDateValue, txtDate, showFullFormat) {

		var dt;

		switch (id) {

			case '1':
				dt = $.datepicker.parseDate('dd.mm.yy', txtDateValue.val());
				txtDate.val($.datepicker.formatDate('dd.mm.yy', dt));
				txtDateInterval.val(1);
				break;
			case '2':
				dt = $.datepicker.parseDate('dd.mm.yy', txtDateValue.val());
				txtDate.val($.datepicker.formatDate('dd.mm.yy', dt));
				txtDateInterval.val(1);
				break;
			case '3':
				dt = $.datepicker.parseDate('dd.mm.yy', txtDateValue.val());
                if (showFullFormat !== true) {
				    txtDate.val($.datepicker.formatDate('M yy', dt));
                }
				var day = parseInt($.datepicker.formatDate('d', dt));
				
				var month = parseInt($.datepicker.formatDate('m', dt));
				var year = parseInt($.datepicker.formatDate('yy', dt));
				if (month === 1) {
					month = 12;
					year -= 1;
				} else {
					month -= 1;
				}
				var daysOfMonth = parseInt(this.getDaysInMonth(month, year));
				if (day > daysOfMonth) {
					daysOfMonth = day + 1;
				} 
				txtDateInterval.val(daysOfMonth);
				break;
			case '4':
				dt = $.datepicker.parseDate('dd.mm.yy', txtDateValue.val());
				if (showFullFormat !== true) {
			        txtDate.val($.datepicker.formatDate('M yy', dt));
			    }
			    txtDateInterval.val(90);
				break;
			case '5':
				dt = $.datepicker.parseDate('dd.mm.yy', txtDateValue.val());
				if (showFullFormat !== true) {
			        txtDate.val($.datepicker.formatDate('yy', dt));
			    }
			    txtDateInterval.val(365);
				break;
		}
    }

	this.getDaysInMonth = function(iMonth, iYear) {
		return new Date(iYear, iMonth, 0).getDate();
    }

    this.initMenuButtons = function(tag) {
        $(tag).button().removeClass('ui-corner-all').addClass('ui-corner-tl').addClass('ui-corner-tr');
        $(tag).removeClass("ui-state-active").removeClass("ui-state-hover").bind('mouseout keyup mouseup mouseenter mouseleave');
        $(tag).filter(".start").addClass("ui-state-active").unbind('mouseout keyup mouseup mouseenter mouseleave');

        $(tag).click(function (ev) {
            ev.preventDefault();
            $(tag).removeClass("ui-state-active").removeClass("ui-state-hover").bind('mouseout keyup mouseup mouseenter mouseleave');
            $(this).addClass("ui-state-active").unbind('mouseout keyup mouseup mouseenter mouseleave');

        });
       
    }

    this.cleanNumber = function (sVal) {
        if (sVal == null) {
            return sVal;
        };
        return sVal.toString().replace(/\./g, '').replace(/\ /g, '');
    }

    this.getTooltipIcon = function (cssclass, text) {
        return "<img src='../../images/info.gif' class='tip_icon " + cssclass + "' title='" + text + "'  /> ";
    }

    this.initTooltip = function (e, pos) {
        e.tipTip({defaultPosition:pos});
    }
}